import SkynetIcon from "../../Fundamentals/SkynetIcon";
import React from "react";
import { useTranslation } from "react-i18next";

export function DynamicInputTable({ children, title }) {
    return (
        <div>
            {title && <legend>{title}</legend>}
            {children}
        </div>
    );
}

export function InputTable({ children, disableAdd, onAdd }) {
    const { t } = useTranslation();

    return (
        <div>
            <table className="table">
                {children}
            </table>
            {onAdd &&
                <div className="float-right">
                    <button type="button" className="btn btn-primary btn-sm" disabled={disableAdd} onClick={onAdd}>
                        {t('common.add')}
                    </button>
                </div>
            }
        </div>
    );
}
export function InputHeader({ children }) {
    return (
        <thead>
            <tr>
                {children}
            </tr>
        </thead>
    );
}

export function InputBody({ children }) {
    return (
        <tbody>
            <tr>
                {children}
            </tr>
        </tbody>
    );
}

export function CurrentTable({ children, title }) {
    const { t } = useTranslation();

    return (
        <table className="table table-stripe">
            <caption>{title ?? t('dynamicinputtable.current')}</caption>
            {children}
        </table>
    );
}

export function CurrentHeader({ children }) {
    return (
        <thead>
            <tr>
                {children}
                <th></th>
            </tr>
        </thead>
    );
}

export function CurrentBody({ children, current, onDelete, onEdit }) {
    const {t} = useTranslation();
    return (
        <tbody>
        {current?.map((item, index) => (
            <tr key={index}>
                {children(item, index)}
                <td>
                    <div className="d-flex justify-content-center gap-12">
                        {onEdit && (
                            <SkynetIcon icon={'vismaicon-edit vismaicon-sm'} title={t('common.edit')}
                                        onClick={() => onEdit(index, item)}/>
                        )}
                        <SkynetIcon icon={'vismaicon-delete vismaicon-sm'} title={t('common.delete')}
                                    onClick={() => onDelete(index)}/>
                    </div>
                </td>
            </tr>
        ))}
        </tbody>
    );
}